export default __webpack_public_path__ + "static/media/bt_burger_close.f5e7364a.svg";